<template>
  <v-container>
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">ข้อมูลของฉัน</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> ข้อมูลของฉัน
      </v-card-title>
      <!-- ส่วนแสดงข้อมูล -->
      <v-form>
        <v-card width="100%" height="100%" elevation="0" class="mb-4" :class="MobileSize ? 'mx-2 mt-2' : ''">
          <v-card elevation="0" width="100%" height="100%" class="pb-8">
            <v-row dense class="mt-2 mb-6 mr-4">
              <v-col cols="12" md="12" class="px-6">
                <v-row justify="end" class="mr-2">
                  <v-btn color="#27AB9C" dark @click="EditDialogAccount = true" outlined tile style="border-radius: 4px;">
                    <v-icon left>mdi-pencil</v-icon>แก้ไขรูปภาพ
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="mt-2">
              <v-col cols="12" md="3" sm="12" class="mr-0">
                <v-row justify="center" align-content="center" dense>
                  <v-card width="150" height="150" rounded :elevation="0">
                    <v-img width="150" height="150" v-if="userImage === null || userImage === ''"  src="@/assets/Gracz/User/noprofile.png" contain/>
                    <v-img width="150" height="150" v-else :src="userImage"/>
                  </v-card>
                </v-row>
              </v-col>
              <v-col cols="12" md="5" sm="12" :align="MobileSize ? 'center' : ''">
                <v-row justify="start" align-content="start" dense>
                  <v-col cols="12" class="font16_400">ชื่อผู้ใช้ :
                    <span class="font16">{{ userName }}</span>
                  </v-col>
                  <v-col cols="12" class="mt-2 font16_400">ชื่อ :
                    <span class="font16">{{ userFirstName + ' ' + userLastName }}</span>
                  </v-col>
                  <v-col cols="12" class="mt-2 font16_400">Email :
                    <span class="font16">{{ userEmail }}</span>
                  </v-col>
                  <v-col cols="12" class="mt-2 font16_400">หมายเลขโทรศัพท์ :
                    <span class="font16">{{ userPhone }}</span>
                  </v-col>
                  <v-col cols="12" class="mt-2 font16_400">ตำแหน่ง :
                    <span class="font16">{{ userPosition }}</span>
                  </v-col>
                  <v-col cols="12" class="mt-2 font16_400">รหัสพนักงาน :
                    <span class="font16">{{ userCode }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-form>

      <!-- Modal Edit User Detail -->
      <v-dialog v-model="EditDialogAccount" persistent width="729">
        <v-card >
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <v-row justify="center" align-content="center">
              <span style="color: #27AB9C; font-size: 24px; font-weight: 700;">แก้ไขข้อมูลส่วนตัว</span>
            </v-row>
            <v-btn fab small @click="CloseDialog()" icon><v-icon color="#27AB9C">mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-container grid-list-xs>
            <v-card-text>
              <v-form ref="FormUserDetail" :lazy-validation="lazy">
                <v-row justify="center" align-content="center" no-gutters>
                  <v-col cols="8"  @click="changePic()">
                    <v-row justify="center" align="center">
                      <!-- <v-hover v-slot="{ hover }"> -->
                        <div class="mx-auto" color="grey lighten-4">
                          <div style="position: relative;" >
                            <v-avatar class='ml-6 mr-7' style="cursor: pointer;" width="106.98" height="160.47" tile>
                              <v-img :src="img_path" v-if="img_path !== null && img_path !== ''" contain></v-img>
                              <v-img v-else src="@/assets/Gracz/User/noprofile.png" class="pointPic" contain></v-img>
                            </v-avatar>
                            <span style="position: absolute; margin-top: 110px; right: 0px; cursor: pointer;"><v-icon color="#27AB9C">mdi-pencil-circle</v-icon></span>
                          </div>
                        </div>
                      <!-- </v-hover> -->
                    </v-row>
                    <v-file-input
                      type="file"
                      style="display: none"
                      ref="image"
                      id="picTure"
                      accept="image/*"
                      @click="event => event.target.value = null"
                      @change="showPicture"
                      :clearable="false"
                    >
                    </v-file-input>
                  </v-col>
                  <v-col cols="8" class="mt-4">
                    <span>ชื่อ <span style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="input_text" placeholder="ระบุชื่อ" outlined dense v-model="userFirstName" :rules="Rules.first_name" counter="20" oninput="this.value = this.value.replace(/[^ก-๏A-Za-z\s]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <span>นามสกุล <span style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="input_text" placeholder="ระบุนามสกุล" outlined dense v-model="userLastName" :rules="Rules.last_name" counter="20" oninput="this.value = this.value.replace(/[^ก-๏A-Za-z\s]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <span>ชื่อผู้ใช้ <span style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="input_text" placeholder="ชื่อผู้ใช้" outlined dense v-model="userName" readonly :rules="Rules.user"></v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <span>เบอร์โทรศัพท์ <span style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="input_text" placeholder="เบอร์โทรศัพท์" outlined dense v-model="userPhone" :maxLength="10" readonly :rules="Rules.tel" oninput="this.value = this.value.replace(/[^0-9\s]/g, '').replace(/(\..*)\./g, '$1')"></v-text-field>
                  </v-col>
                  <v-col cols="8">
                    <span>E-mail <span style="color: red;">*</span></span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field class="input_text" placeholder="E-mail" outlined dense v-model="userEmail" readonly :rules="Rules.emailRules"></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center" align-content="center" dense class="mx-2 mt-4 mb-4">
                  <!-- action -->
                  <v-col cols="12" md="8">
                    <v-row justify="end">
                      <v-btn outlined color="#27AB9C" class="mr-4 pl-8 pr-8" @click="CloseDialog()">ยกเลิก</v-btn>
                      <v-btn color="#27AB9C" dark class="pl-9 pr-9" @click="ConfirmModalEditAccount()">บันทึก</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Modal Confirm Edit Account -->
      <v-dialog v-model="ModalConfirmEditAccount" width="464" persistent>
        <v-card align="center" class="rounded-lg">
          <v-toolbar color="#BDE7D9" dark dense elevation="0">
            <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">แก้ไขข้อมูลส่วนตัว</font></span>
            <v-btn icon dark @click="ModalConfirmEditAccount = !ModalConfirmEditAccount">
              <v-icon color="#27AB9C">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <br/><br/>
          <v-card-text >
            <span>คุณต้องการแก้ไขข้อมูลส่วนตัวหรือไม่</span>
          </v-card-text>
          <v-card-actions >
            <v-container >
              <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="ModalConfirmEditAccount = !ModalConfirmEditAccount">ยกเลิก</v-btn>
              <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="EditAccount()">ตกลง</v-btn>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      userDetailSelling: [],
      seller_shop_id: '',
      // detail
      userImage: '',
      userName: '',
      userFullName: '',
      userEmail: '',
      userPhone: '',
      userPosition: '',
      userCode: '',
      img_path: '',

      // edit
      EditDialogAccount: false,
      lazy: false,
      imageBase: '',
      // confirm dialog
      ModalConfirmEditAccount: false,
      userFirstName: '',
      userLastName: '',
      Rules: {
        username: [
          v => !!v || 'กรุณากรอกชื่อผู้ใช้',
          v => /^[A-Za-z0-9]+$/.test(v) || 'กรอกได้เฉพาะตัวอักษรและตัวเลขเท่านั้น'
        ],
        password: [
          v => !!v || 'กรุณากรอกรหัสผ่าน'
        ],
        first_name: [
          v => !!v || 'กรุณากรอกชื่อจริง',
          v => v.length <= 20 || 'ห้ามกรอกชื่อจริงเกิน 20 ตัวอักษร'
        ],
        last_name: [
          v => !!v || 'กรุณากรอกนามสกุล',
          v => v.length <= 20 || 'ห้ามกรอกนามสกุลเกิน 20 ตัวอักษร'
        ],
        tel: [
          v => !!v || 'กรุณากรอกเบอร์โทรศัพท์',
          v => v.length === 10 || v === '' || 'กรุณากรอกหมายเลขโทรศัพท์ 10 หลัก'
        ],
        emailRules: [
          v => !!v || 'กรุณากรอกอีเมล',
          v => /.+@.+\..+/.test(v) || 'กรุณากรอกอีเมลให้ถูกต้อง',
          v => /^[A-Za-z0-9_@.,/#&+-\s]+$/.test(v) || 'กรุณากรอกเฉพาะภาษาอังกฤษ',
          v => /^\S*$/.test(v) || 'ห้ามใส่ช่องว่างในอีเมล'
        ],
        user: [
          v => !!v || 'กรุณากรอกชื่อผู้ใช้'
        ]
      }
    }
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: '/Order/UserProfileDetailMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/UserProfileDetail' }).catch(() => {})
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    }
  },
  async created () {
    // this.$EventBus.$emit('changeNav')
    this.$EventBus.$emit('enableCartGracz')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        this.seller_shop_id = this.userDetailSelling.seller_shop_id
      }
      this.getProfile()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/UserProfileMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/UserProfile' }).catch(() => {})
      }
    },
    async getProfile () {
      this.$store.commit('openLoader')
      this.img_path = ''
      var data = {
        seller_shop_id: this.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczUserDetailEmployee', data)
      var res = await this.$store.state.ModuleGraczEmployee.stateGraczUserDetailEmployee
      if (res.result === 'SUCCESS') {
        var userDetail = res.data
        this.userName = userDetail.username
        this.userFirstName = userDetail.first_name_th
        this.userLastName = userDetail.last_name_th
        this.userFullName = `${userDetail.first_name_th} ${userDetail.last_name_th}`
        this.userEmail = userDetail.email
        this.userPhone = userDetail.phone
        var position = userDetail.list_shop_detail[0].position
        this.userPosition = position === 'sales' ? 'ฝ่ายขาย' : position === 'super_admin' ? 'ซุปเปอร์แอดมิน' : 'แอดมิน'
        this.userCode = userDetail.list_shop_detail[0].emp_code
        this.userImage = userDetail.img_path
        this.img_path = userDetail.img_path
        this.$store.commit('closeLoader')
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 1500 })
        window.location.assign('/')
      }
      // console.log(this.imageBase)
    },
    CloseDialog () {
      this.img_path = this.userImage
      this.imageBase = ''
      this.$refs.FormUserDetail.resetValidation()
      this.EditDialogAccount = false
    },
    // choose picture
    changePic () {
      document.getElementById('picTure').click()
    },
    showPicture (e) {
      const files = e
      if (files !== undefined) {
        this.imageName = files.name
        const element = files
        const reader = new FileReader()
        reader.readAsDataURL(element)
        reader.onload = () => {
          this.imageBase = reader.result.split(',')[1]
          this.showImage = URL.createObjectURL(element)
          this.img_path = this.showImage
        }
      }
    },
    RemoveImage () {
      this.img_path = ''
      this.imageBase = ''
    },
    ConfirmModalEditAccount () {
      if (this.$refs.FormUserDetail.validate(true)) {
        this.ModalConfirmEditAccount = true
      }
    },
    async EditAccount () {
      this.$store.commit('openLoader')
      this.EditDialogAccount = false
      this.ModalConfirmEditAccount = false
      var data = {
        seller_shop_id: this.seller_shop_id,
        image: this.imageBase,
        first_name_th: this.userFirstName,
        last_name_th: this.userLastName
      }
      await this.$store.dispatch('actionsGraczUpdateProfileEmployee', data)
      var res = await this.$store.state.ModuleGraczEmployee.stateGraczUpdateProfileEmployee
      if (res.result === 'SUCCESS') {
        this.ModalSuccessEditAccount = true
        this.imageBase = ''
        this.getProfile()
        this.$EventBus.$emit('getUserDetail')
        this.$store.commit('closeLoader')
      } else {
        this.$swal.fire({ icon: 'warning', title: 'ไม่สามารถดำเนินการได้', showConfirmButton: false, timer: 1500 })
      }
    }
  }
}
</script>
<style scoped>
.font16_400 {
  font-size: 16px; font-weight: 400; line-height: 24px; color: #333333;
}
.font16 {
  font-size: 16px; font-weight: 700; line-height: 24px; color: #333333;
}
.pointPic {
  opacity: 0.5;
}
.pointPic:hover {
  opacity: 1.0;
}
</style>
